import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import Qs from "qs";
import "./assets/js/component.js";
import { Picker ,Popup} from 'vant';
import 'vant/lib/index.css';
import 'animate.css';

Vue.use(Picker);
Vue.use(Popup);

Vue.config.productionTip = false;
// 传参组件
Vue.prototype.$bus = new Vue();
Vue.prototype.Modal = (title, content, btnTitle, btnCallback) => {
  store.commit("showModal", {
    title: title,
    content: content,
    btnTitle: btnTitle,
    btnCallback: btnCallback
  });
};
// 信息弹窗
Vue.prototype.Toast = (message, show = true) => {
  store.commit('showToast', {
    show: show,
    message: message
  });
};
Vue.prototype.Loading = (show = true) => {
  store.commit("showLoding", show);
};
Vue.prototype.hideModal = () => {
  store.commit("hideModal");
};
// 是否是空值
Vue.prototype.HasData = string => {
  return !!(
    string !== null &&
    string !== undefined &&
    string.toString().replace(/\s/g, '')
  );
};
Vue.prototype.hidePhone = phone => {
  let phoneStr;
  if (typeof (phone) !== 'string') {
    phoneStr = phone.toString();
  } else {
    phoneStr = phone;
  }
  return phoneStr.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
};
Vue.prototype.clearSpace = pass => {
  let passStr;
  if (typeof (pass) !== 'string') {
    passStr = pass.toString();
  } else {
    passStr = pass;
  }
  return passStr.replace(/\s*/g, "");
}
Vue.prototype.hideCard = card => {
  let cardStr;
  if (typeof (card) !== 'string') {
    cardStr = card.toString();
  } else {
    cardStr = card;
  }
  return cardStr.replace(/^(\d{4})\d+(\d{4})$/, '**** **** **** $2');
}// 格式化时间
Vue.prototype.formatDate = time => {
  let newDate = Vue.prototype.isRealDate(time);
  let year = Vue.prototype.numberAddZero(newDate.getFullYear());
  let month = Vue.prototype.numberAddZero(newDate.getMonth() + 1);
  let day = Vue.prototype.numberAddZero(newDate.getDate());
  let hour = Vue.prototype.numberAddZero(newDate.getHours());
  let min = Vue.prototype.numberAddZero(newDate.getMinutes());
  let sec = Vue.prototype.numberAddZero(newDate.getSeconds());
  return `${year}/${month}/${day} ${hour}:${min}:${sec}`;
};
// 判断是否是正确时间格式
Vue.prototype.isRealDate = time => {
  if (time.toString().indexOf('-') > -1) {
    time = time.replace(/-/g, '/');
  }
  let realDate = new Date(time);
  if (typeof time === 'object') { // 如果是实例化的时间
    try {
      realDate = new Date(time);
    } catch (err) {
      return Vue.prototype.Toast('时间格式化输入格式不正确');
    }
  } else if (Number(time).toString() !== 'NaN') { // 如果是一个数字
    try {
      realDate = new Date(time);
    } catch (err) {
      return Vue.prototype.Toast('时间格式化输入格式不正确');
    }
  } else {
    return Vue.prototype.Toast('时间格式化输入格式不正确');
  }
  return realDate;
};
// 数字判断，一位数字前加0
Vue.prototype.numberAddZero = number => {
  number = Number(number);
  return (number < 10 ? '0' + number : number);
};
// 将时间转化为最接近的小时/分/秒，超过24小时，返回时间/传入格式化时间
Vue.prototype.setTimeToPersonRead = time => {
  time = time.replace(/-/g, '/');
  let thisTime = (new Date()).getTime();
  const newTime = (new Date()).getTime();
  try {
    thisTime = (new Date(time)).getTime();
  } catch (err) {
    return Vue.prototype.Toast('传入时间格式不正确');
  }
  const disTime = newTime - thisTime;
  if (disTime > 86400000) { // 大与一天
    return Vue.prototype.formatDate(new Date(time));
  } else if (disTime > 3600000) { // 大于一小时
    return `${Math.floor(disTime / 3600000)}小时前`;
  } else if (disTime > 60000) { // 大于一分钟
    return `${Math.floor(disTime / 60000)}分钟前`;
  } else { // 小于一分钟
    return `${Math.floor(disTime / 1000) ? Math.floor(disTime / 1000) : 1}秒前`;
  }
};

// 判断你是否是微信
Vue.prototype.isWechat = () => {
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true;
  } else {
    return false;
  }
}
// 判断是否是IOS
Vue.prototype.isIos = () => {
  let u = navigator.userAgent;
  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}
// 判断是否是一个手机号
Vue.prototype.isPhone =  (val) => {
  return /^1[3-9]\d{9}$/.test(val);
}
// 判断登录密码是否正确
Vue.prototype.isLoginPass = (pass) => {
  // 6-20位，数字加字母
  return /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/.test(pass);
}
// 判断交易密码是否正确
Vue.prototype.isPayPass = (pass) => {
  // 6位，数字
  return /^[0-9]{6}$/.test(pass);
}
// 截取参数
Vue.prototype.getQueryVariable = (link, variable) =>{
  let vars = link.split("&");
  console.log(vars);
  for (let i=0;i<vars.length;i++) {
    let pair = vars[i].split("=");
    if(pair[0] == variable){return pair[1];}
  }
  return('');
}

if (process.env.NODE_ENV === 'development') {
  Vue.prototype.base_url = '/api/';
} else {
  Vue.prototype.base_url = 'https://web.xuexiguofang.com';
}

Vue.prototype.axios = axios.create({
  baseURL: Vue.prototype.base_url,
  timeout: 20000,
  withCredentials: true,
  transformRequest: [
    function(data) {
      data = Qs.stringify(data);
      return data;
    }
  ],
  headers: { "Content-Type": "application/x-www-form-urlencoded"}
});
// 添加一个请求拦截器
Vue.prototype.axios.interceptors.request.use(function (config) {
  // 在请求发送之前做一些事
  Vue.prototype.Loading();
  return config
}, function (error) {
  // 当出现请求错误是做一些事
  return Promise.reject(error)
})
Vue.prototype.axios.interceptors.response.use(config => {
  Vue.prototype.Loading(false);
  return config;
  // if (config.data.code === 500) {
  // } else {
  // }
}, Toast => {
  Vue.prototype.Loading(false);
  Vue.prototype.Toast('网络错误');
  return Promise.reject(Toast);
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
